import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Alert, Box} from 'views/components';
import {translate} from 'views/module';

import LoomLeadFeed, {LOOM_LEAD_FEED_TABS} from './client_scenes/client_feed/LoomLeadFeed';

import backend from 'utils/backend';

const initialFeedTab = () => {
  const requestedFeedTab = new URLSearchParams(window.location.search).get('feedTab');
  return LOOM_LEAD_FEED_TABS.includes(requestedFeedTab) ? requestedFeedTab : 'WORKFLOWS';
};

// A lead read only from Loom and keyed by its Loom client id. It writes nothing.
const LoomLeadView = (props) => {
  const {clientId} = props;
  const progressWrap = props.statusProgressWrap;

  const [refresh, setRefresh] = React.useState(1);
  const [client, setClient] = React.useState(null);
  const [stage, setStage] = React.useState('LOADING');
  const [feedTab, setFeedTab] = React.useState(initialFeedTab);

  React.useEffect(() => {
    progressWrap(async () => {
      const output = await backend.loom.loomLead.getClient(clientId);
      setClient(output);
    }, {setStage, showProgress: !client, debugString: 'LOOM_LEAD_LOAD'});
  }, [clientId, refresh]);

  if (stage === 'ERROR' && !client) {
    return (
      <Alert severity='error'>
        {translate('loomLead.LoomLeadDetail.LoadError')}
      </Alert>
    );
  }

  if (!client) return null;

  return (
    <Box
      sx={{
        textAlign: 'left',
        width: {
          xs: '100%',
          md: '75%',
        },
      }}
    >
      <LoomLeadFeed
        clientId={clientId}
        clientData={client.clientDetail}
        clientCareplan={client.careplan}
        clientCareviewSettings={client.careview}
        feedTab={feedTab}
        setFeedTab={setFeedTab}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </Box>
  );
};

LoomLeadView.propTypes = {
  clientId: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(LoomLeadView));
